import request from '@/router/axios'

const eventBase = '/api/produce/emergency-event'

export const report = (data) => {
  return request({
    url: `${eventBase}/report`,
    method: 'post',
    data
  })
}
